module.exports = __webpack_public_path__ + "static/media/khaikhoangdetail.44d1f618.png";